import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import MessagePage from '@dashboard/components/pages/MessagePage';
import { Container } from '@mui/material';

import LoadingIndicator from '../components/loading/LoadingIndicator';

type TState = { status: 'LOADING' | 'ERROR' } | { status: 'COMPLETED'; href: string };

export default function Auth0Callback(): JsxNode {
  const { handleRedirectCallback } = useAuth0();
  const [state, setState] = useState<TState>({ status: 'LOADING' });

  useEffect(() => {
    void handleRedirectCallback()
      .then((result) => {
        setState({
          status: 'COMPLETED',
          href: result.appState?.returnTo ?? '/',
        });
      })
      .catch(() => {
        setState({ status: 'ERROR' });
      });
  }, [state, handleRedirectCallback, setState]);

  switch (state.status) {
    case 'LOADING':
      return (
        <Container maxWidth="sm">
          <LoadingIndicator />
        </Container>
      );
    case 'ERROR':
      return (
        <MessagePage
          icon="ERROR"
          title="Log-in error"
          description="There was an error logging you in"
          action={
            <ButtonLink variant="contained" href="/">
              Retry
            </ButtonLink>
          }
        />
      );
    case 'COMPLETED':
      return <Navigate to={state.href} replace />;
  }
}
